import { render, staticRenderFns } from "./CarHistory.vue?vue&type=template&id=37db4df7&"
import script from "./CarHistory.vue?vue&type=script&lang=js&"
export * from "./CarHistory.vue?vue&type=script&lang=js&"
import style0 from "./CarHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports